import { adminRepositories } from "data/admin/repositories";

export const usersRepo = {
  list(params) {
    return adminRepositories.users.list(params);
  },

  getById(id) {
    return adminRepositories.users.getById(id);
  },

  create(input) {
    return adminRepositories.users.create(input);
  },

  update(id, patch) {
    return adminRepositories.users.update(id, patch);
  },

  remove(id) {
    return adminRepositories.users.remove(id);
  },

  restore(id) {
    return adminRepositories.users.restore(id);
  },
};